<template>
  <div class="home">
    <iframe style="width: 100%; height: 100%" @load="load" :src="src" ref="iframeDom" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      key: 'e164e4ee-a42f-4c9b-937e-a4d8a315f6c0',
      glbComponent: null,
      sweepList: null,
      currentdata: '',
      sweep_index: null,
      audioUrl: '',
      isPlaying: false,
      is_true: false
    }
  },
  computed: {
    src() {
      return this.$store.state.settings.iframeUrl + '&vvvvv=' + new Date().getTime()
    }
  },

  methods: {
    load(e) {
      var MPSDK = window.MP_SDK || e.target.contentWindow.MP_SDK
      try {
        MPSDK.connect(e.target, this.key || 'e164e4ee-a42f-4c9b-937e-a4d8a315f6c0', '3.2')
          .then(async sdk => {
            this.$emit('ready', sdk)
            this.currentSweep(sdk)
            window.sdk = sdk
          })
          .catch(e => {
            console.error(e)
          })
      } catch (e) {
        console.error(e)
      }
    },

    currentSweep(mpSdk) {
      const that = this
      mpSdk.Sweep.current.subscribe(function(currentSweep) {
        const arr = [
          // 前言
          ['87c3707e7c65429c8055c3276b4d07fe'],
          // 伟人风采
          ['1371f9bd0e9146ccb141002ec36e839f', '11db995dfede48e6ae14425357b5d370', 'fa06bd8efac549268e80a16823592d19', '965a0cc7a68f444985c31397747133db', 'c39c7d383601445686a82e3fcc14d57e', '56d7cf99b35a49aa8f5426c5e0f97555', 'bce58e3d7c4f42a49a69b6b9455e5019'],
          // 革命圣地
          ['932d3977ae444ef283a493c6a6000de2', 'a5a159104a804544b31039bf44388e88', '384d72ea083241f1ad04576fa281c0ab', '3d7b8962a8bd491d89bc5dfb56a54ecd', 'f6d8c483d1f94ce4b1d34e5edbea13a4', '3ca48c58256548b3a7cbbd6c7205db5d', '3388d87b3c5b4f09a7e5ff37ae074ad3', '47f4dc58db5e48f080f029f01888153a', '69144cb6f1da490aa79266c5fcf57b72', '2583d66bdc1a47e6a926f1a499bbabe3', '6e4701d7a229424aa2cd3845cb683380', '9234c2f0ec264ca1a29b5e129c8e3b0f', '82abe4e318d14d29b81a4fe0ad7a2dba'],
          // 革命人物
          ['c1c995cb8e814f10a1e26541738824ff', '21a7421cbf994e2782273d4e62d9cd81', 'daa3c9ce46bd4667b24d183545907dc0', '34c39d80d1f945e5a8482a3044aea98b', 'a7045e1ef742428c9762ce5d196dab4f', '2a5e045381254ef4ac7d8e862a256bc3', '81f3a9b36def42bbb4b538cc5b37c657'],
          // 样板戏
          ['5c0959925b07446a9c6e92154c3804b0', 'b430b3c1df134845b36f27d220cb6960', 'ed3a42329c1e4913a718970395a15be8'],
          // 纯音乐
          ['5c56328ce02442aab243b2ac6c7875bd', '9490a4f4002347daaf91955aa90ad710', 'be0916ac0c6d4f4dba241845a164c3db', '488038221afb45069b22da67dda07ce8']
        ]

        // console.log(currentSweep.sid)
        if (currentSweep.sid) {
          arr.forEach((item, index) => {
            if (item.includes(currentSweep.sid)) {
              that.$store.commit('settings/SWEEP_INDEX', index)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.home {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.help {
  width: 800px;
  height: 60px;
  z-index: 999999;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
